module.exports = __webpack_public_path__ + "static/average-age-pid-3cff35a8b1fafddbf1d5db74c1f8336e.svg";